<div class="positionQuickActions">
  <mat-icon class="pointer" [ngClass]="canReset() ? '':'disabled'" (click)="resetPosition($event)" svgIcon="close"
    #tooltipMin="matTooltip" matTooltipPosition="above" matTooltip="Zerar Posição"></mat-icon>
</div>
